import { ListDto } from "../types/dto";
import * as invitationService from '../services/invitationService';
import { useMutation, useQuery } from "react-query";

const getTeamInvitationsRequests = async (dto: ListDto) => {
    return await invitationService.getTeamInvitationsRequests(dto);
}

const approveTeamInvitationRequest = async (requestId: string) => {
    return await invitationService.approveTeamInvitationRequest(requestId);
}

const rejectTeamInvitationRequest = async (requestId: string) => {
    return await invitationService.rejectTeamInvitationRequest(requestId);
}

// ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

export const useGetTeamInvitationsRequests = (dto: ListDto, options = {}) => {
    return useQuery({
        queryKey: ['teamInvitations', dto],
        queryFn: () => getTeamInvitationsRequests(dto),
        ...options
    });
}

export const useApproveTeamInvitationRequest = (onSuccess: any, onError: any) => {
    return useMutation(approveTeamInvitationRequest, {
        onSuccess,
        onError
    });
}

export const useRejectTeamInvitationRequest = (onSuccess: any, onError: any) => {
    return useMutation(rejectTeamInvitationRequest, {
        onSuccess,
        onError
    });
}